import React from 'react';
import {connect} from 'react-redux';

import ReportController from '../classes/report'

import {RefreshReport, Suggest, ExpiredExclusions,
	ScrollBox, Fail
} from '../components/report/report_components'

import TitleRow from '../components/report/title';
import WhosAccount from "../components/report/whosaccount"
import ExecutiveSummary from './ExecutiveSummary';
import HistorySummary from "./HistorySummary";
import Security from '../components/report/security/security';
import Stability from '../components/report/stability/stability';
import Licensing from '../components/report/licensing/licensing';


const mapStateAsProps = state =>({
	urlParams: state.projectInfo.urlParams,
	report: state.projectInfo.report,
	summary: state.projectInfo.summary,
	reportOriginal: state.projectInfo.reportOriginal,
	projectInfo: state.projectInfo.projectInfo,
	titleState: state.projectInfo.titleState,
	hasError: state.projectInfo.errorReport,
	exclusions: state.projectInfo.exclusionsMap,
	user: state.setUser.user,
	security: state.projectInfo.security,
	stability: state.projectInfo.stability,
	licensing: state.projectInfo.licensing,
	jiraInfo: state.projectInfo.jiraInfo || null,
	recentlyExpiredExclusions: state.projectInfo.recentlyExpiredExclusions
})


const {$}=window;


const Head = (props)=>{
	const { loadPage, recompute, openDependenciesTree, projectsController}=props.parentProps;
	const {refreshReport} = props;
	return(
		<React.Fragment>
			<TitleRow 
				refreshDialog={refreshReport}
				recompute = {recompute}
				openDependenciesTree={openDependenciesTree}
				loadPage = {loadPage}
				projectsController = {projectsController}
				badgesReady = {props.state.overviewReady}
			/>
			<WhosAccount />
		</React.Fragment>
	)
}







const Main = (props)=>{
	const {refresh, securityReady, mitigationsReady, stabilityReady,  licensingReady, licensingIssues, overviewReady, sidebar, noIssues, jiraInfo}=props.state;
	const {timestamp, status} = props.parentProps.report;
	const {urlParams, projectInfo, titleState, report, hasError=false, renderId="notknown",
		summary, findDependencyInTree, user, recentlyExpiredExclusions}=props.parentProps;

	const universalFindDependencyInTree = (language, library, preventCases )=>{
		if(preventCases){
			if(preventCases.key && preventCases.key.toLowerCase()!="enter") return
			if(preventCases.blurry) return
			if(preventCases.notLatest) return
		}

        findDependencyInTree(language,library)
    }

	const {hasLicenses} = titleState;

	const issues = (!noIssues)?{securityReady,stabilityReady,licensingIssues}:{};

	const accountScopes = user && user.account && user.account.properties && user.account.properties.configuration && user.account.properties.configuration.analysisScopes?
		user.account.properties.configuration.analysisScopes:{ security:"all", stability:"all", licensing: "all"}

	const projectScopes = report.scopes

	const scopes = projectScopes || accountScopes
	
	return hasError || !report.status || (report.status!=="OK" && report.status!=="PARTIAL")?
			<Fail status={status}/>
			:
			<React.Fragment>
				<RefreshReport display={refresh} />
				<Suggest display={urlParams.hl} url={projectInfo.title} />
				<ExpiredExclusions display={!!(recentlyExpiredExclusions && recentlyExpiredExclusions.length)} />

				<ExecutiveSummary renderId={renderId} 
					overviewReady={overviewReady}
					issues = {issues} partialBuild={status==='PARTIAL'?true:false} shouldShowLicenses={hasLicenses}
					timestamp={timestamp} urlParams={urlParams} display={sidebar} summary = {summary} scopes={scopes}
				/>

				<HistorySummary projectsController = {props.parentProps.projectsController} />

				<ScrollBox security={securityReady} stability={stabilityReady} licensing={licensingReady} mitigations={mitigationsReady} />

				<Security 
					display={securityReady || mitigationsReady} securityReady={securityReady} 
					displayMitigations={mitigationsReady}
					findDependencyInTree={universalFindDependencyInTree}
					jiraInfo={jiraInfo}
				/>

				<Stability 
					display={stabilityReady} renderId={props.renderId} findDependencyInTree={universalFindDependencyInTree}
				/>
				<Licensing 
					display={licensingReady} renderId={renderId} findDependencyInTree={universalFindDependencyInTree}		
				/>


				
				
			</React.Fragment>
}







class Report extends React.Component{
	constructor(props){
		super(props)
		this.state={
			ready:false,
			refresh: false,
			sidebar: true,
			securityReady: false,
			mitigationsReady: false,
			stabilityReady: false,
			licensingReady: false,
		}

		this.fulfilled=false
		this.readyTimeout=null;
		this.ready=false;
		this.reportController = new ReportController({'Authorization': window.auth.helpers.header()})
		
	}

	

	refreshReport=async()=>{
		const {pid,branch} = this.props.urlParams;
		const refresh = await this.reportController.refresh(pid,branch);
		this.setState({refresh})
	}

	preprocessReport(){

		if(this.props.hasError) {
			this.setState({ready: true});
			return
		}
		const countDomainsTotals = ()=>{
			const {vulnerabilities,exclusions} = security.issues

			const totStability=stability.reports.reduce((tot,report)=>tot+report.versions.length,0);
			const licensingIssues=licensing.licensing.warningsCount+licensing.licensing.violationsCount;
			const totLicensing=licensing.section.standard.reduce((acc,{results})=>acc+results.length,0)


			return{ 
				security: vulnerabilities,
				securityExclusions: exclusions,
				stability: totStability,
				licensing: totLicensing,
				licensingIssues
			}

		}

		const security = this.props.security
		const stability = this.props.stability.stability
		const licensing = this.props.licensing

		const {status}=this.props.report;
		if(status!=="OK" && status!=="PARTIAL"){
			this.setState({ready: true,sidebar: false});
			return;
		} 
		const privateMode= this.props.urlParams.mode;
		const {isAccountDefault}=this.props.titleState;
		
		const totals = countDomainsTotals();
		
		const grandTotal = totals.security+totals.stability+totals.licensing;
	
		if(grandTotal>0){
			const securityReady = totals.security>0 && totals.security>totals.securityExclusions;
			const mitigationsReady = totals.securityExclusions>0;
			const stabilityReady = totals.stability>0;
			const licensingReady = !privateMode || !isAccountDefault? totals.licensing > 0 : false;
			const licensingIssues = licensingReady && totals.licensingIssues>0;
			this.setState({
				ready:true,	securityReady, mitigationsReady, stabilityReady, licensingReady, licensingIssues,
				overviewReady: {
					security: security.security.assessments.length, 
					stability: stability.reports.length, 
					licensing: licensing.section.standard.length
				}
			})
		}
		else{
			this.setState({ready: true,overviewReady: false, noIssues: true, licensingReady: totals.licensing>0})
		}
	}


	getSnapshotBeforeUpdate(nextProps){
		return JSON.stringify(nextProps.report)!==JSON.stringify(this.props.report)
	}
	componentDidUpdate(prevProps,prevState,snapshot){
		if(snapshot)
			this.preprocessReport();
	}

	componentDidMount(){
		this.preprocessReport();
	}	

	fulfillDeepLink(){


		if ( this.props.rendersCount>1)
			return

		if(this.ready || !window.location.hash) return;
		clearTimeout(this.readyTimeout)
		this.readyTimeout = setTimeout(()=>{
			this.ready=true;
			let hash = window.location.hash
			hash = hash.replace("#","")
			hash = window.$.escapeSelector(hash)
			hash = "#"+hash

			$("html,body").animate({scrollTop: $(hash).offset().top})
			this.fulfilled = true
		},1000)
	}
	
	render(){
		if(!this.state.ready) return ""
		setTimeout(()=>{
			this.fulfillDeepLink()
		},1000)
		return(
			<div className="report-section default" id="report">
	    		<div className="container report-container">
					<Head 
						parentProps={this.props} 
						state={this.state} 
						refreshReport={this.refreshReport}
					/>
					<Main 
						parentProps={this.props} 
						state={this.state}
					/>
	    		</div>
	    	</div>

		)
	}
}

export default connect(mapStateAsProps)(Report);